import SkeletonImage from './SkeletonImage';
import { INTRO } from '../constants/content';

export default function Intro() {
  return (
    <section className="intro" id="about">
      <div className="shell intro__grid">
        <div className="intro__figure">
          <SkeletonImage
            src={INTRO.image}
            alt="Printer producing a colour page"
            width={800}
            height={533}
            sizes="(max-width: 768px) 100vw, 45vw"
          />
        </div>
        <div className="intro__copy">
          <h2>
            <span className="ink">{INTRO.titleDark}</span>{' '}
            <span className="red">{INTRO.titleRed}</span>
          </h2>
          <p>{INTRO.body}</p>
        </div>
      </div>
    </section>
  );
}
